import { render, staticRenderFns } from "./SuccessNotification.vue?vue&type=template&id=c135e5ce"
import script from "./SuccessNotification.vue?vue&type=script&lang=js"
export * from "./SuccessNotification.vue?vue&type=script&lang=js"
import style0 from "./SuccessNotification.vue?vue&type=style&index=0&id=c135e5ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports